<template>
    <div class="row pattern">
            <section style="display: flex; justify-content: center;">
                <div class="Video-border GameplayContainer" style="position:relative;">
                    <span class="Video-border Video-border--top"></span>
                    <span class="Video-border Video-border--right"></span>
                    <span class="Video-border Video-border--bottom"></span>
                    <span class="Video-border Video-border--left"></span>
                    <span class="Video-corner Video-corner--topLeft"></span>
                    <span class="Video-corner Video-corner--topRight"></span>
                    <span class="Video-corner Video-corner--bottomRight"></span>
                    <span class="Video-corner Video-corner--bottomLeft"></span>
                
                    <div class="pattern-dark clearfix">
                        <iframe id="GameplayView" width="560" height="315" src="https://www.youtube.com/embed/nXgv50ANmK4?si=gkD7uBzD-GXvziAp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen="true" scrolling="no"></iframe>
                    </div>
                </div>
            </section>
            <section class="wallpapers" id="wallpapers">
                <viewer :options="options" @inited="inited">
                    <div class="container">
                        <div class="row">
                            <h2>Screen Shots</h2>
                        </div>
                        <div class="row items-container" >
                            <div class="col-xs-5 gallery-item item-1 thumbnail-50" @click="show(0)">
                                <img src="@/assets/community/embersadrift-screenshot-01.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-01.jpg" key="embersadrift-screenshot-01.jpg" class="image" alt="Embers Adrift Community Screenshot 01">
                            </div>
                            <div class="col-xs-5 col-xs-offset-2 gallery-item item-2 thumbnail-50" @click="show(1)">
                                <img src="@/assets/community/embersadrift-screenshot-02.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-02.jpg" key="embersadrift-screenshot-02.jpg" class="image" alt="Embers Adrift Community Screenshot 02">
                            </div>
                        </div>
                        <div class="row items-container" >
                            <div class="col-xs-5 gallery-item item-1 thumbnail-50" @click="show(2)">
                                <img src="@/assets/community/embersadrift-screenshot-03.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-03.jpg" key="embersadrift-screenshot-03.jpg" class="image" alt="Embers Adrift Community Screenshot 03">
                            </div>
                            <div class="col-xs-5 col-xs-offset-2 gallery-item item-2 thumbnail-50" @click="show(3)">
                                <img src="@/assets/community/embersadrift-screenshot-04.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-04.jpg" key="embersadrift-screenshot-04.jpg" class="image" alt="Embers Adrift Community Screenshot 04">
                            </div>
                        </div>
                        <div class="row items-container" >
                            <div class="col-xs-5 gallery-item item-1 thumbnail-50" @click="show(4)">
                                <img src="@/assets/community/embersadrift-screenshot-05.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-05.jpg" key="embersadrift-screenshot-05.jpg" class="image" alt="Embers Adrift Community Screenshot 05">
                            </div>
                            <div class="col-xs-5 col-xs-offset-2 gallery-item item-2 thumbnail-50" @click="show(5)">
                                <img src="@/assets/community/embersadrift-screenshot-06.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-06.jpg" key="embersadrift-screenshot-06.jpg" class="image" alt="Embers Adrift Community Screenshot 06">
                            </div>
                        </div>
                        <div class="row items-container" >
                            <div class="col-xs-5 gallery-item item-1 thumbnail-50" @click="show(6)">
                                <img src="@/assets/community/embersadrift-screenshot-07.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-07.jpg" key="embersadrift-screenshot-07.jpg" class="image" alt="Embers Adrift Community Screenshot 07">
                            </div>
                            <div class="col-xs-5 col-xs-offset-2 gallery-item item-2 thumbnail-50" @click="show(7)">
                                <img src="@/assets/community/embersadrift-screenshot-08.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-08.jpg" key="embersadrift-screenshot-08.jpg" class="image" alt="Embers Adrift Community Screenshot 08">
                            </div>
                        </div>
                        <div class="row items-container" >
                            <div class="col-xs-5 gallery-item item-1 thumbnail-50" @click="show(8)">
                                <img src="@/assets/community/embersadrift-screenshot-09.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-09.jpg" key="embersadrift-screenshot-09.jpg" class="image" alt="Embers Adrift Community Screenshot 09">
                            </div>
                            <div class="col-xs-5 col-xs-offset-2 gallery-item item-2 thumbnail-50" @click="show(9)">
                                <img src="@/assets/community/embersadrift-screenshot-10.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-10.jpg" key="embersadrift-screenshot-10.jpg" class="image" alt="Embers Adrift Community Screenshot 10">
                            </div>
                        </div>
                        <div class="row items-container" >
                            <div class="col-xs-5 gallery-item item-1 thumbnail-50" @click="show(10)">
                                <img src="@/assets/community/embersadrift-screenshot-11.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-11.jpg" key="embersadrift-screenshot-11.jpg" class="image" alt="Embers Adrift Community Screenshot 11">
                            </div>
                            <div class="col-xs-5 col-xs-offset-2 gallery-item item-2 thumbnail-50" @click="show(11)">
                                <img src="@/assets/community/embersadrift-screenshot-12.jpg" data-source="https://downloads.embersadrift.com/community/embersadrift-screenshot-12.jpg" key="embersadrift-screenshot-12.jpg" class="image" alt="Embers Adrift Community Screenshot 12">
                            </div>
                        </div>
                    </div>
                </viewer>
            </section>
        </div>
</template>
<script>
  import 'viewerjs/dist/viewer.css'
  import Viewer from "v-viewer/src/component.vue"

  export default {
    name: 'InGameComponent',
    components: { Viewer },
    data() {
      return {
        options: {
            toolbar: false,
            navbar: false,
            url: 'data-source'
        }
      }
    },
    methods: {
        inited (viewer) {
            this.$viewer = viewer
        },
        show (i) {
            this.$viewer.view(i)
        }
    }
  }
</script> 